<div class="h-full">
    @if (isLoading()) {
        <div class="h-full flex flex-col">
            <app-loading
                class="m-auto"
                size="30" />
        </div>
    } @else {
        <app-entity-detail-template
            [attributesInformation]="layerAttributesInformation()"
            [bookmarkedAttributes]="bookmarkedAttributes()"
            [canReadDocuments]="canReadDocuments()"
            [columnsByName]="columnsByName()"
            [dataEntity]="dataEntity()"
            [documentData]="documentData()"
            [geomBboxEntity]="geomBboxEntity()"
            [hasBoxOrBayPlan]="isBoxOrBayPlanAvailable()"
            [hasOpticalPath]="isOpticalPathAvailable()"
            [hasSynoptic]="isSynopticAvailable()"
            [identifier]="identifier"
            [isEntityUsedInBreak]="isEntityUsedInBreak()"
            [notBookmarkedAttributes]="notBookmarkedAttributes()"
            (centerMapOnEntityAndZoomIn)="centerMapOnEntityAndZoomIn()"
            (exportOpticalPath)="exportOpticalPath()"
            (goToPreviousPage)="goToPreviousPage()"
            (goToSynopticPanel)="openSynopticPanel()"
            (openBoxOrBayPlan)="openBoxOrBayPlan()"
            (openBreakModal)="openBreakModal()"
            (viewOpticalPath)="navigateToNetworkPath()">
            @if (layer()) {
                <div class="flex flex-row items-center">
                    <span class="font-normal text-xl break-words">
                        {{ layer()!.name }}
                    </span>
                </div>
            } @else if (fieldIntervention()) {
                <span class="font-normal text-xl mt-1 break-words">
                    {{ fieldIntervention()!.name }}
                </span>
            }
            @if (fieldInterventionEntity()) {
                @for (list of [formItemsWithState(), peopleItemsWithState()]; track $index) {
                    <div class="mt-2">
                        <app-field-intervention-entity-items-list
                            [items]="list"
                            [title]="['form', 'operator'][$index]" />
                    </div>
                }
            }
        </app-entity-detail-template>
    }
</div>
